export const MAX_BILLING_NUMBER_LENGTH = 42;

export const BILLING_NUMBER_SPACE_ERROR =
  'Spaces are not permitted. Special Characters that are permitted are “{} [] () / ~ - , ; : . < >“.';

export const BILLING_NUMBER_MAX_LENGTH_ERROR = `Billing PO/Project Number cannot exceed ${MAX_BILLING_NUMBER_LENGTH} characters.`;

export const BILLING_CODE_ALREADY_USED_WARNING =
  'This BILLING CODE has already been used for another invoiced surveys.';
